
import Convert from "../../../assets/outline/Convert.svg";

import { IconProps } from "../../../types";

const cx = require('classnames');

export default function ConvertIcon({ className, dataTestid = "ConvertIcon", ...rest }: IconProps) {
  const classes = cx(className);

  return (
    <Convert data-testid={dataTestid} className={classes} {...rest} />
  );
}
